import React from 'react';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

import styles from './PatientAutoVerify.module.scss';

interface Props {
	isOpen: boolean;
	onClose: () => void;
}

const PatientAutoVerifyNotInsuredModal: React.FC<Props> = ({
	isOpen,
	onClose,
}) => (
	<BaseModal
		isOpen={isOpen}
		onClose={onClose}
		title='nczi.verifyPatientInsurance.title'>
		<>
			<Text tx='nczi.patientAutoVerify.notInsuredText' firstUpper />
			<div className={styles.controls}>
				<Button
					theme={Theme.GREEN}
					title='base.shared.continue'
					onClick={onClose}
					fitContent
				/>
			</div>
		</>
	</BaseModal>
);

export default PatientAutoVerifyNotInsuredModal;
